<template>
  <div class="commission-detail">
    <loading :isShow="listLoading" />
    <div class="table" id="tableBox">
      <div class="table-wrap">
        <div class="head-wrap" id="headWrap1">
          <div
            v-for="(item, index) in columns"
            :key="index"
            class="head"
            :style="
              item.width ? 'width:' + item.width + 'px;flex:0 0 ' + item.width + 'px;' : '' + item.minWidth ? 'min-width:' + item.minWidth + 'px;flex:1;' : ''
            "
            :class="{
              'sort': item.type == 'index',
              'tools-wrap': item.key == 'commission' && item.totalCommission == item.commissionIndex,
              'left': item.fixed == 'left',
              'left-1': item.slot == 'gradeCode',
              'left-2': item.slot == 'programId'
            }"
          >
            <span v-if="item.title">{{ item.title }}</span>
            <span v-if="item.key == 'commission' && item.totalCommission == item.commissionIndex && tableData.length && formData.versionType != -1">
              <i
                v-if="item.commissionIndex != 1 && !single"
                class="ivu-icon ivu-icon-md-close-circle"
                @click="
                  delYear({
                    commissionIndex: item.commissionIndex
                  })
                "
              ></i>
              <i
                v-if="!single"
                class="ivu-icon ivu-icon-md-add-circle"
                @click="
                  addYear({
                    commissionIndex: item.commissionIndex + 1
                  })
                "
              ></i>
              <Checkbox
                v-if="item.commissionIndex > 5"
                v-model="single"
                @on-change="$event => setFullYear({ untilLast: $event, commissionIndex: item.commissionIndex })"
                >至交费期满</Checkbox
              >
            </span>
            <span v-else-if="item.key == 'commission' && item.totalCommission == item.commissionIndex && tableData.length &&formData.versionType == -1 && single">
              至交费期满
            </span>
          </div>
        </div>
        <div v-if="tableData.length" class="content-wrap" id="contentBody1">
          <div v-for="(item, index) in tableData" :key="item.programId + index" :id="'p' + formData.productCode + item.gradeCode" class="content-limit-1">
            <div
              class="box"
              v-for="(column, idx) in columns"
              :key="idx"
              :style="
                column.width
                  ? 'width:' + column.width + 'px;flex:0 0 ' + column.width + 'px;'
                  : '' + column.minWidth
                  ? 'min-width:' + column.minWidth + 'px;flex:1;'
                  : ''
              "
              :class="{
                'sort': column.type == 'index',
                'tools-wrap': column.key == 'commission' && column.totalCommission == column.commissionIndex,
                'right': column.fixed == 'right',
                'left': column.fixed == 'left',
                'left-1': column.slot == 'gradeCode',
                'left-2': column.slot == 'programId'
              }"
            >
              <template v-if="column.type == 'index'">{{ index + 1 }}</template>
              <template v-else-if="column.slot == 'gradeCode'">
                {{ tableData[index].gradeCode | getProductName(productAdditions) }}
              </template>
              <template v-else-if="column.slot == 'programId'">
                <editRateSelect v-model="tableData[index].programId" disabled :list="programBases" />
              </template>
              <template v-else-if="column.key != 'commission' && column.key">
                {{ tableData[index] | getFactor(column) }}
              </template>
              <template v-else-if="column.key == 'commission'">
                <span>{{ tableData[index].innerCommissions[column.commissionIndex - 1].value }}</span>
              </template>
              <template v-else>{{ tableData[index][column.key] }}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModalRef"></confirm-modal>
  </div>
</template>
    
    <script>
import filter from '@/api/filter';
import { common } from '@/api/mixins';
import editRateSelect from './editRateSelect';
import confirmModal from '@/components/commons/confirmModal';
export default {
  components: { editRateSelect, confirmModal },
  mixins: [common],
  filters: {
    getFactor(val, item) {
      return val.factors.find(i => i.roleCode == item.key) ? val.factors.find(i => i.roleCode == item.key).remark : '-';
    },
    getProductName(val, arr) {
      if (!arr || arr.length == 0) {
        return '';
      } else {
        return arr.find(i => i.gradeCode == val)?.name;
      }
    }
  },
  data() {
    return {
      filter,
      programBases: [], //方案列表
      productAdditions: [],
      listLoading: false,
      single: false,
      tableData: [],
      formData: {
        productId: '',
        productCode: '',
        productCategory: '',
        versionNo: '',
        versionEndTime: '',
        versionStartTime: '',
        versionType:''
      },
      columns: [],
      innerCommissionsColumns: [],
      allProgramFactors: []
    };
  },
  methods: {
    async init(data) {
      console.log('--------', data);
      if (data.versionNo) {
        this.formData.versionNo = data.versionNo;
        this.formData.productCategory = data.productCategory;
        this.formData.versionEndTime = data.versionEndTime;
        this.formData.versionStartTime = data.versionStartTime;
        this.formData.productId = data.productId;
        this.formData.productCode = data.productCode;
        this.formData.versionType = data.versionType;
        let res = await this.getAllProgramFactors();
        this.allProgramFactors = res.data;
        await this.queryGradeTreeByPlatformId();
        this.getDetail();
      }
    },

    // 设置至交费期满
    async setFullYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$nextTick(() => {
          this.single = !params.untilLast;
        });
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: params.untilLast ? '/buz/upcommission/setCommissionUntilLast' : '/buz/upcommission/cancelCommissionUntilLast',
        type: 'POST',
        data: {
          versionNo: this.formData.versionNo,
          commissionIndex: params.commissionIndex,
          productCode: this.formData.productCode
        }
      })
        .then(async res => {
          this.getDetail();
          this.pageLoading = false;
        })
        .catch(() => {
          this.$nextTick(() => {
            this.single = !params.untilLast;
          });
          this.pageLoading = false;
        });
    },
    // 新增交费年限
    async addYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.listLoading = true;
      this.$http({
        url: '/buz/upcommission/addCommissionNum',
        type: 'POST',
        data: {
          versionNo: this.formData.versionNo,
          commissionIndex: params.commissionIndex,
          productCode: this.formData.productCode,
          commissionList: this.tableData.map(item => {
            return {
              isMain: item.isMain,
              gradeCode: item.gradeCode,
              programId: item.programId,
              commission: 0
            };
          })
        }
      })
        .then(res => {
          this.listLoading = false;
          this.getDetail();
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    // 删除交费年限
    async delYear(params) {
      this.$refs.confirmModalRef
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(async () => {
          if (!this.$units.pointAction('pro_7_1')) {
            this.$notice.error('无权操作，请联系您的上级');
            return;
          }
          this.listLoading = true;
          this.$http({
            url: '/buz/upcommission/delCommissionNum',
            type: 'POST',
            data: {
              versionNo: this.formData.versionNo,
              commissionIndex: params.commissionIndex,
              productCode: this.formData.productCode
            }
          })
            .then(res => {
              this.listLoading = false;
              this.getDetail();
            })
            .catch(() => {
              this.listLoading = false;
            });
        });
    },
    queryGradeTreeByPlatformId() {
      return this.$http({
        url: '/buz/programBase/queryGradeTreeById',
        type: 'GET',
        data: {
          id: this.formData.productId,
          programType: this.formData.productCategory == 3 ? 1 : 2
        }
      }).then(res => {
        this.productAdditions = res.data.productAdditions; //主险&&附加险
        this.programBases = res.data.programBases; //所有方案
      });
    },
    getDetail() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commission/gradeProgramCommissionQueryByVersion',
        type: 'GET',
        data: {
          versionNo: this.formData.versionNo,
          productCode: this.formData.productCode
        }
      }).then(res => {
        this.innerCommissionsColumns = [];
        this.formData.commissionNum = res.data.commissionNum;
        this.formData.templateId = res.data.templateId;
        this.formData.untilLastCommissionIndex = res.data.untilLastCommissionIndex;
        this.tableData = res.data.commissionList || [];

        this.single = res.data.untilLastCommissionIndex > 0;
        let arr = [];
        if (res.data.commissionList && res.data.commissionList.length) {
          res.data.commissionList.forEach(item => {
            arr.push(...item.factors);
          });
        }
        let len =
          res.data.commissionList && res.data.commissionList.length && res.data.commissionList[0].innerCommissions
            ? res.data.commissionList[0].innerCommissions.length
            : res.data.commissionNum;

        for (let index = 0; index < len; index++) {
          this.innerCommissionsColumns[index] = {
            key: 'commission',
            title: index == 0 ? '首年（%）' : `第` + this.$units.numberTransform(index + 1) + `年（%）`,
            commissionIndex: index + 1,
            totalCommission: len,
            width: index + 1 == len ? (index > 4  && this.formData.versionType != -1? 300 : 160) : 120
          };
        }
        this.getProgramIdColumns(arr);
        this.listLoading = false;
      });
    },
    getAllProgramFactors() {
      return this.$http({
        url: '/buz/programRule/getAllRule',
        type: 'GET',
        data: {}
      });
    },
    getProgramIdColumns(arr) {
      let columns = [];
      arr.forEach(factorItem => {
        if (columns.findIndex(column => column.key == factorItem.roleCode) == -1) {
          let factor = this.allProgramFactors.find(item => item.code == factorItem.roleCode);
          if (factor.code != 'LK000011' || this.formData.productCategory == '3') {
            columns.push({
              title: factor.name,
              key: factorItem.roleCode,
              align: 'center',
              render: (h, params) => {
                let factor = params.row.factors.find(i => i.roleCode == params.column.key);
                return <span>{factor ? factor.remark || '-' : '-'}</span>;
              },
              minWidth: 150
            });
          }
        }
      });
      this.columns = [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          fixed: 'left',
          width: 80
        },
        {
          title: '险种名称',
          slot: 'gradeCode',
          align: 'center',
          minWidth: 260,
          fixed: 'left'
        },
        {
          title: '方案名称',
          slot: 'programId',
          align: 'center',
          minWidth: 260,
          fixed: 'left'
        },
        ...columns,
        ...this.innerCommissionsColumns
      ];

      this.$nextTick(() => {
        const arr = document.getElementsByClassName('content-limit-1');
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (document.getElementById(element.id.replace('p', 'b'))) {
            document.getElementById(element.id.replace('p', 'b')).style.height = element.clientHeight + 'px';
          }
        }
        if (document.getElementById('contentBody1')) {
          document.getElementById('contentBody1').style.width = document.getElementById('headWrap1').scrollWidth + 'px';
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.commission-detail {
  .table-wrap {
    padding-bottom: 20px;
    background-color: #fff;
    border-right: 0;
    border-bottom: 0;
    color: #3c464f;
    font-size: 13px;
    overflow: auto;
    max-height: calc(100vh - 140px);
    display: flex;
    flex-wrap: wrap;
    max-width: calc(100vw - 50px);
    width: min-content;
    .left-1 {
      z-index: 5;
      position: sticky;
      flex: 0 0 260px;
      left: 80px;
    }
    .left-2 {
      z-index: 5;
      position: sticky;
      flex: 0 0 260px;
      left: 340px;
    }
    .sort {
      z-index: 5;
      position: sticky;
      left: 0px;
      width: 60px;
      flex: 0 0 60px;
    }
    .right {
      position: sticky;
      right: 0px;
      z-index: 5;
      border-left: 1px solid #e9e9e9;
      background-color: #fff;
    }
    .head-wrap {
      height: 45px;
      width: inherit;
      line-height: 45px;
      display: flex;
      flex-wrap: nowrap;
      position: sticky;
      top: 0;
      z-index: 6;
      .head {
        display: inline-block;
        background-color: #f7f7f7;
        text-align: center;
        width: 140px;
        flex: 0 0 140px;
        flex-wrap: nowrap;
        border-right: 1px solid #e9e9e9;
        border-top: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        align-items: center;
        justify-content: center;
        &:first-child {
          border-left: 1px solid #e9e9e9;
        }
        .ivu-icon-md-add-circle,
        .ivu-icon-md-close-circle {
          color: rgb(35, 109, 255);
          font-size: 24px;
          cursor: pointer;
        }
        .ivu-icon-md-close-circle {
          color: rgb(242, 104, 104);
        }
      }
      .tools-wrap {
        width: 300px;
        flex: 0 0 300px;
        span {
          display: flex;
          align-items: center;
        }
        display: flex;
        align-items: center;
      }
    }
    .content-wrap {
      width: 100%;
      .content-limit-1 {
        position: relative;
        width: 100%;
        &:hover {
          .box {
            background-color: #ebf7ff !important;
          }
        }
        display: flex;
        .box {
          background-color: #fff;
          display: block;
          display: flex;
          width: 140px;
          justify-content: center;
          min-height: 50px;
          align-items: center;
          text-align: center;
          padding: 0 4px;
          height: auto;
          flex: 0 0 140px;
          border-bottom: 1px solid #e9e9e9;
          border-right: 1px solid #e9e9e9;
          &:first-child {
            border-left: 1px solid #e9e9e9;
          }
        }
        .tools-wrap {
          width: 300px;
          flex: 0 0 300px;
        }
      }
    }
  }
}
</style>
    